//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

import Grid from "@material-ui/core/Grid";
import React, { useEffect } from "react";

import { withStyles } from "@material-ui/core/styles";

import Box from "@material-ui/core/Box";
import { architectureURLs } from "../AllImages/architecture";
import { wallpapersURLs } from "../AllImages/wallpapers";
import { birdsURLs } from "../AllImages/birds";
import { compositionURLs } from "../AllImages/composition";
import { geometryURLs } from "../AllImages/geometry";
import { landscapeURLs } from "../AllImages/landscape";
import { manipulationURLs } from "../AllImages/manipulation";
import { moonURLs } from "../AllImages/moon";
import { portraitURLs } from "../AllImages/portrait";
import { streetURLs } from "../AllImages/street";
import { travelURLs } from "../AllImages/travel";
import swal from "@sweetalert/with-react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import { useSpring, animated } from "react-spring/web.cjs";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import InfiniteScroll from "react-infinite-scroll-component";

//......keep this import at last......
import { useStyles } from "./Styles";

const Fade = React.forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  );
});

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "lightgray",
    color: "rgba(0, 0, 0, 1)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
  },
}))(Tooltip);

let enableZoom = false;
function IndividualCategory(props) {
  const classes = useStyles();
  // var onWindows = React.useState("");
  // onWindows = /Windows/i.test(navigator.userAgent);
  var normalScreen = React.useState(Boolean);
  normalScreen = window.matchMedia("(min-width: 769px)").matches;
  var mobileScreen = React.useState(Boolean);
  mobileScreen = window.matchMedia("(max-width: 768px)").matches;
  // const [loader, triggerLoader] = React.useState(true);
  // const typeToFetch = React.useState(props.typeToRender);
  const [tileData, setTileData] = React.useState([]);
  const [items, setItems] = React.useState([]);
  const [lowerBound, updateLowerBound] = React.useState(0);
  const [upperBound, updateUpperBound] = React.useState(12);
  const [moreDataForScroll, triggerMoreDataForScroll] = React.useState(true);
  const [currentImg, setCurrentImg] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [streetTiles] = React.useState(streetURLs);
  const [portraitTiles] = React.useState(portraitURLs);
  const [travelTiles] = React.useState(travelURLs);
  const [moonTiles] = React.useState(moonURLs);
  const [compositionTiles] = React.useState(compositionURLs);
  const [birdsTiles] = React.useState(birdsURLs);
  const [geometryTiles] = React.useState(geometryURLs);
  const [manipulationTiles] = React.useState(manipulationURLs);
  const [landscapeTiles] = React.useState(landscapeURLs);
  const [architectureTiles] = React.useState(architectureURLs);
  const [wallpapersTiles] = React.useState(wallpapersURLs);

  const fetchListOfImages = () => {
    if (props.typeToRender === "Street") {
      setTileData(streetTiles);
    } else if (props.typeToRender === "Portraits") {
      setTileData(portraitTiles);
    } else if (props.typeToRender === "Travel") {
      setTileData(travelTiles);
    } else if (props.typeToRender === "Moon & Space") {
      setTileData(moonTiles);
    } else if (props.typeToRender === "Composition") {
      setTileData(compositionTiles);
    } else if (props.typeToRender === "Birds & Nature") {
      setTileData(birdsTiles);
    } else if (props.typeToRender === "Geometry") {
      setTileData(geometryTiles);
    } else if (props.typeToRender === "Manipulations") {
      setTileData(manipulationTiles);
    } else if (props.typeToRender === "Landscapes") {
      setTileData(landscapeTiles);
    } else if (props.typeToRender === "Architecture") {
      setTileData(architectureTiles);
    } else if (props.typeToRender === "Wallpapers") {
      setTileData(wallpapersTiles);
    } else return true;
  };

  const handleOpen = (event) => {
    // document.getElementsByClassName("grid-image")[0].style.filter = "grayscale(0.8)"
    event.preventDefault();
    setOpen(true);
    setCurrentImg(event.target.src);
    enableZoom = true;
    window.addEventListener("wheel", zoom);

  };
  const handleClose = (event) => {
    event.preventDefault();
    setOpen(false);
    setCurrentImg("");
    enableZoom = false;
  };

  let scale = 92;

  function zoom(event) {
    if (enableZoom) {
      let elem = document.getElementById("indImage");
      var defaultWidth = event.target.clientWidth;
      // console.log("default width is: ", defaultWidth);

      if (event.deltaY === -100) {
        // console.log("mouse up, TODO: ZOOM IN");
        scale += event.deltaY * -0.01;
        elem.style.maxHeight = scale + "vh";
      } else if (event.deltaY === 100) {
        // console.log("mouse down, TODO: ZOOM OUT");
        scale += event.deltaY * -0.01;
        elem.style.maxHeight = scale + "vh";
      }
    } else {
      return false;
    }
  }

  useEffect(() => {
    fetchListOfImages();
    if (tileData.length > 0) {
      dataFetch();
    }
    // const id = setTimeout(() => triggerLoader(false), 3300);
  }, [props.typeToRender, tileData]);

  const GlobalCss = withStyles({
    "@global": {
      ".MuiGrid-grid-md-4": {
        maxWidth: "33%",
      },
      ".MuiGrid-grid-xs-6": {
        maxWidth: "33%",
      },
    },
  })(() => null);

  const dataFetch = () => {
    // console.log("data fetch called");
    if (upperBound >= tileData.length) {
      // console.log("size less than 12");
      var concatinatedArray = tileData.slice(lowerBound, tileData.length);
      // console.log("pushing1", concatinatedArray.length, "elements");
      items.push(...concatinatedArray);
      setTimeout(() => triggerMoreDataForScroll(false), 2500);
      // setItems(tileData.slice(lowerBound, tileData.length));
      // triggerMoreDataForScroll(false);
    } else {
      // console.log("12 elements pushed");
      var concatinatedArray = tileData.slice(lowerBound, upperBound);
      // console.log("pushing2 ", concatinatedArray.length, "elements");
      items.push(...concatinatedArray);

      // setItems(tileData.slice(lowerBound, upperBound));
      updateLowerBound(lowerBound + 12);
      updateUpperBound(upperBound + 12);
    }
  };

  const fetchMoreData = () => {
    if (tileData.length > 0 && moreDataForScroll) {
      if (lowerBound + 12 >= tileData.length) {
        // console.log("final push");
        var concatinatedArray = tileData.slice(lowerBound, tileData.length);
        // console.log("pushing3 ", concatinatedArray.length, "element(s)");
        items.push(...concatinatedArray);
        // triggerMoreDataForScroll(false);
        setTimeout(() => triggerMoreDataForScroll(false), 2500);
      } else {
        // console.log("pushing next batch");
        // console.log("upper bound is: ", upperBound);
        // console.log("tile length is: ", tileData.length);
        dataFetch();
      }
    } else {
      triggerMoreDataForScroll(false);
      // console.log("you have seen them all");
    }
  };

  return (
    <React.Fragment>
      <InfiniteScroll
        dataLength={items.length}
        next={fetchMoreData}
        scrollableTarget="infiScroll"
        hasMore={moreDataForScroll}
        loader={
          <div style={{ textAlign: "center", marginTop: "10%" }}>
            <img src="images/loader.gif" alt="" />
            <h4>Loading...</h4>
          </div>
        }
        endMessage={
          <p style={{ textAlign: "center", color: "#4d8a5dd9" }}>
            Yay! you have seen them all
          </p>
        }
      >
        <div className={classes.root2}>
          <Grid container spacing={2} className={classes.gridList}>
            <GlobalCss />
            {items.map((tile) => (
              <Grid item xs={4} sm={3} md={4} lg={3}>
                <HtmlTooltip
                  title={
                    <React.Fragment>
                      <strong>In frame:</strong> {tile.frame}, <br />{" "}
                      <strong>Location:</strong> {tile.location}
                    </React.Fragment>
                  }
                  arrow
                  interactive
                >
                  <a style={{ cursor: "pointer" }} onClick={handleOpen}>
                    <img
                      className="grid-image"
                      src={tile.img}
                      alt=""
                    />
                  </a>
                </HtmlTooltip>
                {mobileScreen ? (
                  <Box fontStyle="oblique" fontSize="small">
                    <strong>In frame:</strong> {tile.frame}, <br />{" "}
                    <strong>Location:</strong> {tile.location}
                  </Box>
                ) : null}
              </Grid>
            ))}
          </Grid>
        </div>
      </InfiniteScroll>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div
            style={{
              backgroundColor: "#fff0",
              // boxShadow: "1px 1px 29px 8px #2f2f2f",
              
            }}
          >
            <HtmlTooltip
              title="Scroll to zoom in/out, click outside the image to exit"
              arrow
              interactive
            >
              <img id="indImage" name="indImage" src={currentImg} />
            </HtmlTooltip>
          </div>
        </Fade>
      </Modal>
    </React.Fragment>
  );
}
export default IndividualCategory;
